import styled from 'styled-components'

const Container = styled.div`
  width: 73.5416666667%;
  margin: 0 auto;
  ${props => props.custom_styles}
`

export default Container
